'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var MODULE_NAME = exports.MODULE_NAME = 'viewport';

var prefix = MODULE_NAME + '/';

var ACTION_TYPES = exports.ACTION_TYPES = {
    VIEWPORT_CHANGED: prefix + 'CHANGED'
};